import QRCode from 'qrcode'

export const dataToUrl = async (data: string) => {
    return await QRCode.toDataURL(data, {
        errorCorrectionLevel: 'L',
     });
}
